module.exports = __webpack_public_path__ + "static/WeGlot1-6354df4218b1cc94d367684e6140a1eb.jpg";